import React from 'react';
import PropTypes from 'prop-types';

const ArrowLeft = ({ color, ...props }) => (
  <svg viewBox="0 0 7 11.6" {...props}>
    <path
      fill={color}
      d="M6.6 11.6c-.1 0-.2 0-.3-.1L.1 6.1c0-.1-.1-.2-.1-.3 0-.1.1-.2.1-.3L6.3.1c.2-.1.5-.1.6 0 .1.2.1.5 0 .6L1 5.8l5.8 5.1c.2.1.2.4 0 .6 0 .1-.1.1-.2.1z"
    ></path>
  </svg>
);

ArrowLeft.propTypes = {
  color: PropTypes.string
};

export default ArrowLeft;
